import { ProductPrice } from "@/api/product-api";

export const useProductPrice = (
  productPrice: ProductPrice | null | undefined,
): {
  displayDiscountAmount: number;
  displayOriginalPrice: number;
  displaySalePrice: number;
  displayDicountPercent: number;
  hasActualDiscount: boolean;
} => {
  const {
    discountAmount = 0,
    displayAmount = 0,
    originalAmount = 0,
  } = productPrice ?? {};

  const displayDiscountAmount = displayAmount - originalAmount + discountAmount;
  const displayDicountPercent = Math.round(
    (displayDiscountAmount / displayAmount) * 100,
  );
  const hasActualDiscount = discountAmount > 0;

  return {
    displayDiscountAmount,
    displayOriginalPrice: displayAmount,
    displaySalePrice: originalAmount - discountAmount,
    displayDicountPercent,
    hasActualDiscount,
  };
};
